import React, { useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import AuthService from "../../../Services/authService";
import { toast } from "react-toastify";
import "../../../auth-modern.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();

  const email = location.state?.email || "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!", { autoClose: 4000 });
      return;
    }

    const body = {
      token,
      password,
      confirmPassword,
    };

    AuthService.resetPassword(body)
      .then((res) => {
        toast.success(res.data?.message || "Password reset successfully");
        navigate("/");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong, try again!");
      });
  };

  return (
    <div className="auth-modern-wrapper">
      <div className="auth-modern-card">
        <div className="auth-logo-container">
          <Link to="/">
            <img src="/assets/images/logo-dark.png" alt="logo" height={32} />
          </Link>
        </div>

        <h2 className="auth-welcome-text">Set New Password</h2>

        <div className="alert alert-success text-center mb-4" style={{ fontSize: '13px', borderRadius: '8px' }}>
          Enter your new password below!
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-input-group">
            <input
              type="password"
              className="auth-input"
              placeholder=" "
              id="userpassword"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="auth-label" htmlFor="userpassword">New Password</label>
          </div>

          <div className="auth-input-group">
            <input
              type="password"
              className="auth-input"
              placeholder=" "
              id="confirm-password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <label className="auth-label" htmlFor="confirm-password">Confirm Password</label>
          </div>

          <div className="mt-4">
            <button className="auth-primary-btn" type="submit">
              Reset Password
            </button>
          </div>

          <div className="mt-4 text-center">
            <p className="mb-0" style={{ fontSize: '13px' }}>
              Remember it? <Link to="/" className="auth-link">Signin</Link>
            </p>
          </div>
        </form>

        <p className="auth-footer-text">
          © {new Date().getFullYear()} Planit. Developed by <a href="https://websouls.com/" target="_blank" rel="noopener noreferrer" className="auth-link">WebSouls</a>
        </p>

      </div>
      
      <div className="auth-bottom-help">
        <Link to="/">Need help?</Link>
      </div>
    </div>
  );
};

export default ResetPassword;
